import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Caso, EstadoCaso } from 'src/app/models/Caso';
import { CasosapiService } from 'src/app/services/casosapi.service';
import { environment } from 'src/environments/environment';
import { showLoading, hideLoading } from '../../../redux/actions/loading.actions';
import { LoadingState } from 'src/app/redux/reducers/loading.reducer';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-verpaso4',
    templateUrl: './verpaso4.component.html',
    styleUrls: ['./verpaso4.component.scss'],
    standalone: false
})
export class Verpaso4Component implements OnInit {

  error: boolean;
  caso: Caso = { id: 0, paciente: '', genero: 0, fechaNacimiento: '', ci: '', user_id: 0, status: EstadoCaso.PAGO_TRATAMIENTO_REALIZADO, latitudEntrega: '-17.783202', longitudEntrega: '-63.181687' };
  modalRechazar: any;
  marker: any = {
    position: {
      lat: Number(this.caso.latitudEntrega),
      lng: Number(this.caso.longitudEntrega),
    },
    title: 'Ubicación actual ',
    options: { animation: google.maps.Animation.BOUNCE },
  }

    ;
  // Configuración de Google Maps 
  center = {
    lat: Number(this.caso.latitudEntrega),
    lng: Number(this.caso.longitudEntrega),
  };
  zoom = 15;
  display?: google.maps.LatLngLiteral;

  constructor(
    private actRoute: ActivatedRoute,
    private api: CasosapiService,
    private router: Router,
    private modalService: NgbModal,
    private storeLoading: Store<LoadingState>

  ) {
    this.actRoute.params.subscribe(data => {
      if (data.id) {
        this.getCaso(data.id);
      }
    });
  }

  ngOnInit() {
  }
  getCaso(id: string) {
    this.storeLoading.dispatch(showLoading({ loadingText: "Obteniendo datos del paciente..." }));

    this.api.getCaso(id).subscribe(data => {
      if (data) {
        this.caso = data;
        if (this.caso.latitudEntrega) {
          this.changeMarkerLocation(Number(this.caso.latitudEntrega), Number(this.caso.longitudEntrega));
        }
        this.error = false;
      } else {
        this.error = true;
      }
      // console.log(data);

      this.storeLoading.dispatch(hideLoading());
    });
  }
  getImageUrl(file: string) {
    return environment.baseUrl + '/files/archivoscaso/' + this.caso.id + '/' + file + '.jpg';
  }
  aprobarComprobante() {
    this.api.aprobarcasostep4(this.caso).subscribe(data => {
      // console.log(data);
      this.router.navigateByUrl('/casos/' + this.caso.id + '/verpaciente');
    }, (error) => {
      console.log(error);
    });
  }
  rechazarComprobante() {
    this.api.rechazarComprobanteStep4(this.caso).subscribe(data => {
      // console.log(data);
      this.modalRechazar.close();
      this.router.navigateByUrl('/casos/' + this.caso.id + '/verpaciente');
    }, (error) => {
      console.log(error);
    });
  }
  rechazar(content) {
    this.modalRechazar = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

    this.modalRechazar.result.then((result) => { }, (reason) => { });
  }
  changeMarkerLocation(lat, lng) {
    this.marker = {
      position: {
        lat: lat,
        lng: lng,
      },
      title: 'Ubicación actual ',
      options: { animation: google.maps.Animation.BOUNCE },
    };
    this.center = {
      lat: lat,
      lng: lng,
    };
  }
}
